export enum StatusGroupEnum {
  ALL = "ALL",
  QUOTED = "QUOTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  HOVER_QUOTED = "HOVER_QUOTED",
}
